import axios from "axios";
const state = {};
import config from "@/../config";
const defaultErrorHandler = error => Promise.reject(error.response);

const mutations = {};

const actions = {

    async GET_BANK({
        commit
    }, payload) {
        let response = await axios.get(config.apiUrl + config.versoes[0] + "/bancos/");
        return response.data;
    },

    ME_INFO({
        commit
    }, payload) {
        return axios.get(config.apiUrl + config.versoes[0] + "/usuarios/eu/").then(response => {
            store.commit("SET_ME", response.data);
            return response.data;
        }).catch(error => {
            return Promise.reject(error.response);
        });
    },

};

export default {state, mutations, actions};



// WEBPACK FOOTER //
// ./src/store/modules/broker.js